module.exports = __webpack_public_path__ + "static/img/OOSH_007.992af49.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_007.jpg
// module id = OFmw
// module chunks = 170